import { defineMessages } from 'react-intl';

export default defineMessages({
    loadingNextPageMessageRewrite: {
        id: 'Rewrite.ea.views.ea-vehicle-details.Loading next page...',
        defaultMessage: 'Loading next page...'
    },
});
